import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "underline-icon",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.65272 2.49268C5.65272 2.1475 5.3729 1.86768 5.02772 1.86768C4.68254 1.86768 4.40272 2.1475 4.40272 2.49268V9.19773C4.40272 12.2868 6.90694 14.7911 9.99605 14.7911C13.0852 14.7911 15.5894 12.2868 15.5894 9.19773V2.49268C15.5894 2.1475 15.3096 1.86768 14.9644 1.86768C14.6192 1.86768 14.3394 2.1475 14.3394 2.49268V9.19773C14.3394 11.5965 12.3948 13.5411 9.99605 13.5411C7.5973 13.5411 5.65272 11.5965 5.65272 9.19773V2.49268Z" }, null, -1),
    _createElementVNode("path", { d: "M2.49924 16.8826C2.15406 16.8826 1.87424 17.1624 1.87424 17.5076C1.87424 17.8528 2.15406 18.1326 2.49924 18.1326H17.5C17.8452 18.1326 18.125 17.8528 18.125 17.5076C18.125 17.1624 17.8452 16.8826 17.5 16.8826H2.49924Z" }, null, -1)
  ])))
}
export default { render: render }